import { useEffect, useState } from "react";

export default function LoadingComponent() {
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    fetch("/parameters/theme.json")
      .then((res) => (res.ok ? res.json() : null))
      .then((theme) => {
        if (theme?.loading_logo) {
          setLogo("data" + theme.loading_logo.split(";data")[1]);
        } else {
          if (theme?.header_logo) {
            setLogo("data" + theme.header_logo.split(";data")[1]);
          }
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="loader">
      {logo && <img src={logo} alt="" className="loader-logo" />}
      <div className="loader-dots">
        <span />
        <span />
        <span />
      </div>
      <p className="loader-text">CHARGEMENT DE VOTRE ESPACE</p>
    </div>
  );
}
